import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { Reveal, SectionHeading } from "../Reveal";
import { useContent } from "../../context/ContentContext";

export const FAQ = () => {
  const { faqs } = useContent();
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="bg-navy-50/60 py-24" data-testid="faq-section">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading center eyebrow={faqs.eyebrow} title={faqs.title} />
        </Reveal>

        <div className="mt-12 space-y-3">
          {faqs.items.map((f, i) => {
            const active = open === i;
            return (
              <Reveal key={i} delay={i * 0.05}>
                <div className="overflow-hidden rounded-xl border border-gray-200 bg-white">
                  <button
                    onClick={() => setOpen(active ? -1 : i)}
                    data-testid={`faq-toggle-${i}`}
                    className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                  >
                    <span className="font-display text-base font-bold text-navy">{f.q}</span>
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${active ? "bg-brandred text-white" : "bg-navy-50 text-navy"}`}>
                      {active ? <Minus size={16} /> : <Plus size={16} />}
                    </span>
                  </button>
                  <div className={`grid transition-all duration-300 ${active ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                    <div className="overflow-hidden">
                      <p className="px-6 pb-5 text-sm leading-relaxed text-muted-foreground">{f.a}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
